import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-charcoal" data-id="element-56" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-57" data-mp="83m65m9gpava">
        <p className="inline-block rounded bg-red-600 px-2 py-0.5 font-display text-xs font-bold uppercase tracking-widest text-white" data-id="element-58" data-mp="m46nsf3n50n7">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/80" data-id="element-59" data-mp="vui4z3cc56c1">
          Podés seguir guardando videos sobre melamina, cortes, planos,
          bisagras y armado de muebles sin saber qué deberías aprender primero.
          O podés comenzar hoy a desarrollar una nueva habilidad siguiendo una
          ruta organizada desde cero.
        </p>
        <h2 id="cierre" className="mt-2 font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-60" data-mp="zua4yrnny45s">
          No necesitás ser experto en carpintería para empezar.{' '}
          <span className="text-cta" data-id="element-61" data-mp="2h5u6b14gp6iw">Necesitás dar el primer paso.</span>
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-dashed border-cta bg-white p-3 text-charcoal" data-id="element-62" data-mp="2m1j7f8w4qvhb">
          <p className="font-display text-sm font-black uppercase leading-tight text-wood" data-id="element-63" data-mp="2qzui1lu91a0l">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-anton text-2xl uppercase tracking-wide" data-id="element-64" data-mp="302c0rqap3kiu">
            6 Tomos + 5 Bonos
          </p>
          <p className="text-xs text-charcoal/80 sm:text-sm" data-id="element-65" data-mp="34udbv8w4n57a">
            Valor de los bonos:{' '}
            <span className="text-red-600 line-through" data-id="element-66" data-mp="39rdhxjsz87ye">{BONUS_VALUE}</span>
          </p>
          <p className="mt-1 font-display text-5xl font-extrabold leading-none tracking-tight text-wood sm:text-6xl" data-id="element-67" data-mp="3esayjryc8txs">
            <span className="text-3xl italic text-charcoal sm:text-4xl" data-id="element-68" data-mp="3itwk01oxugjl">
              Hoy:
            </span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-69" data-mp="1ep8qrsuf9c8u">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-medium text-charcoal/80" data-id="element-70" data-mp="1sgwyljxn1ek0">
            <span className="flex items-center gap-1" data-id="element-71" data-mp="1nodqh2hpzbml">
              <ZapIcon size={12} className="text-wood" data-id="element-72" data-mp="22ebftlrdy7dd" />
              Acceso Inmediato
            </span>
            <span className="text-charcoal/40" data-id="element-73" data-mp="1xgjdryx114vg">•</span>
            <span data-id="element-74" data-mp="1xhuh5xmk8am1">Entrega Digital</span>
            <span className="text-charcoal/40" data-id="element-75" data-mp="2bg14wkxsou7z">•</span>
            <span className="flex items-center gap-1" data-id="element-76" data-mp="2bdezorydmqsx">
              <ShieldCheckIcon size={12} className="text-wood" data-id="element-77" data-mp="27ez6u7fm6o7l" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}